import { Injectable } from '@angular/core';
import { NativeDateAdapter, MatDateFormats, MAT_DATE_FORMATS } from '@angular/material/core';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {

  // Override parse to accept "dd/MM/yyyy" formatted strings and return Date objects
  override parse(value: any): Date | null {

    if (typeof value === 'string' && value.length === 10) {
      const parts = value.split('/');
      if (parts.length === 3) {
        const day = Number(parts[0]);
        const month = Number(parts[1]) - 1; // month is zero-based
        const year = Number(parts[2]);
        // Validate month and year
        if (!isNaN(day) && !isNaN(month) && !isNaN(year) && month >= 0 && month <= 11) {
          // Check if the day is valid for the given month and year
          const date = new Date(year, month, day);
          if (date.getFullYear() === year && date.getMonth() === month && date.getDate() === day) {
            return date; // Return valid date
          }
        }
      }
    }
    return null; // Return null for invalid parsing
  }

  // Override format to display date in "dd/MM/yyyy" format
  override format(date: Date, displayFormat: string | object): string {

    if (!date) {
      return '';
    }

    // Format the date to "dd/MM/yyyy"
    const day = this._to2digit(date.getDate());
    const month = this._to2digit(date.getMonth() + 1); // Months are zero-based
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  private _to2digit(n: number): string {

    return n < 10 ? '0' + n : n.toString();
  }
}

// Custom date formats to tell Angular Material how to parse/format dates
export const CUSTOM_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};
